module.exports = __webpack_public_path__ + "img/legumesecrases.3d3ccb59.png";